(function () {
  function initProductSlider(root) {
    var slider = root.querySelector('[data-lp-wmc-slider]');
    if (!slider) return;

    var track = slider.querySelector('[data-lp-wmc-slider-track]');
    var slides = slider.querySelectorAll('[data-lp-wmc-slider-slide]');
    var prev = slider.querySelector('[data-lp-wmc-slider-prev]');
    var next = slider.querySelector('[data-lp-wmc-slider-next]');
    if (!track || !slides.length) return;

    var index = 0;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translate3d(' + index * -100 + '%, 0, 0)';
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    goTo(0);
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-lp-wmc-sticky-bar]');
    var checkSec = document.getElementById('lp-wmc-check-sec');
    if (!bar) return;

    function update() {
      var show = false;

      if (checkSec) {
        var rect = checkSec.getBoundingClientRect();
        show = rect.top < window.innerHeight * 0.85;
      } else {
        show = window.scrollY > 400;
      }

      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    initProductSlider(root || document);
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
